import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Componentes
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';

//Helpers
import { objCampo } from '../../helpers/ValidadorDeCampos';
import { validarCampos } from '../../helpers/ValidadorDeCampos';
import mascaras from '../../helpers/mascaras';
import { showMessage, showQuestion } from 'helpers/message';

//Context
import { useAuth } from '../../context/auth';


//API
import inscricaoMunicipal_api from '../../api/inscricaoMunicipal_api';
import gerador_api from '../../api/gerador_api';
import prefeitura_api from '../../api/prefeitura_api';

function initialStateInscricoesMunicipais() {
  return {
    tbGerador_id: "",
    cnpj: "",
    razaoSocial: "",
    inscricaoMunicipal: ""
  }
}

function NovoInscricoesMunicipais({ btnVoltar, inscricaoMunicipal = null, filtro = null }) {
  const { session, setLoading } = useAuth();

  const [inscricao, setInscricao] = useState(inscricaoMunicipal ?? initialStateInscricoesMunicipais());

  const [errors, setErrors] = useState({});

  //Estado que guarda as opções do select de geradores
  const [optionsGeradores, setOptionsGeradores] = useState([]);

  //campos para validação
  const [campos, setCampos] = useState([
    objCampo({ name: "cnpj", required: true, cnpj: true }),
    objCampo({ name: "razaoSocial", required: true }),
    objCampo({ name: "inscricaoMunicipal", required: true })
  ]);

  //onChange para os outros campos conferindo se os obrigatorios estão vazios e mostrando erro se sim
  const onChangeInscricoesMunicipais = (e) => {
    const { name, value } = e.target;
    const _inscricao = {
      ...inscricao,
      [name]: value
    };

    const campo = campos.filter(c => c.name == name);
    const erros = validarCampos(_inscricao, campo);
    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    } else {
      setErrors({ ...errors, ...erros[0] });
    }

    setInscricao(_inscricao);
  }

  const AddInscricaoMunicipal = () => {
    const _errors = validarCampos(inscricao, campos);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return;

    const _inscricao = { ...inscricao };

    if (session.acesso.sigla == "GG")
      _inscricao.tbGerador_id = session.acesso.acesso_id;


    if (!_inscricao.id) {
      setLoading(true);

      inscricaoMunicipal_api.Post(_inscricao).then(response => {
        showMessage("Sucesso", "Inscrição municipal criada com sucesso!", "success", btnVoltar)
      }).catch(error => showMessage("Error", error.message, "error", null))
        .finally(() => setLoading(false))
    } else {
      setLoading(true);
      inscricaoMunicipal_api.Put(_inscricao).then(response => {
        showMessage("Sucesso", "Inscrição municipal Atualizada com sucesso!", "success", btnVoltar)
      }).catch(error => showMessage("Error", error.message, "error", null))
        .finally(() => setLoading(false))
    }
  }

  function excluirInscricao() {
    showQuestion("Aviso", "Tem certeza que deseja deletar esta Inscrição Municipal? Esta ação é irreversível", "info", (confirmation) => {
      if (confirmation) {
        setLoading(true)
        const _inscricao = { ...inscricao };
        _inscricao.dataExclusao = moment().format();
        inscricaoMunicipal_api.Put(_inscricao).then(response => {
          showMessage("Sucesso", "Inscrição municipal excluída com sucesso!", "success", btnVoltar)
        }).catch(error => showMessage("Error", error.message, "error", null))
          .finally(() => setLoading(false))
      }
    })
  }

  //Função de onChange do campo de fiscal do agendamento
  const onChangeSelect = (e, select) => {
    const { name } = select;

    const _inscricao = {
      ...inscricao,
      [name]: e && e.value ? e.value.toString() : ""
    };

    const erros = validarCampos(_inscricao, campos.filter(c => c.name == name));
    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    }

    setInscricao(_inscricao);
  }

  const loadGeradores = () => {
    setLoading(true);
    prefeitura_api.GetList().then(response => {
      gerador_api.GetList(response.data[0].id).then(response => {
          response.data = response.data.map(value => {
              return { label: value.fantasia, value: value.id }
          });
          setOptionsGeradores(response.data);
      }).catch(e => {
          showMessage("Aviso", e.message, "error", null);
      }).finally(_ => setLoading(false));
  });
  }

  useEffect(() => {
    if (session && session.acesso.sigla == "GS") {
      loadGeradores();
      
      if (filtro && filtro?.tbGerador_id != "")
        setInscricao({ ...inscricao, tbGerador_id: filtro?.tbGerador_id.toString() })

      setCampos([...campos, objCampo({ name: "tbGerador_id", required: true })])
    }
  }, [])

  return <>
    <MainCard btnVoltar={btnVoltar} btnExcluir={inscricao?.id ? () => excluirInscricao() : null}>
      <Row>
        {session && session.acesso.sigla == "GS" &&
          <Col md="12" lg={"12"}>
            <TextField
              label={"* Geradores"}
              name={"tbGerador_id"}
              type={"select"}
              options={optionsGeradores}
              searchable
              onChange={onChangeSelect}
              value={optionsGeradores.filter(x => x.value == inscricao.tbGerador_id)[0]}
              invalid={errors.tbGerador_id}
            />
          </Col>
        }
        <Col md={"12"} lg={"4"}>
          <TextField
            maxLength={"18"}
            label={"* CNPJ"}
            invalid={!!errors.cnpj}
            value={inscricao.cnpj}
            onChange={onChangeInscricoesMunicipais}
            name="cnpj"
            mask={mascaras.cpfcnpjMask}
          />
        </Col>
        <Col md={"12"} lg={"4"}>
          <TextField
            maxLength={"100"}
            label={"* Razão Social"}
            invalid={!!errors.razaoSocial}
            value={inscricao.razaoSocial}
            onChange={onChangeInscricoesMunicipais}
            name="razaoSocial"
          />
        </Col>
        <Col md={"12"} lg={"4"}>
          <TextField
            maxLength={"30"}
            label={"* Inscrição Municipal"}
            invalid={!!errors.inscricaoMunicipal}
            value={inscricao.inscricaoMunicipal}
            onChange={onChangeInscricoesMunicipais}
            name="inscricaoMunicipal"
          />
        </Col>
      </Row>
      <div className='d-flex justify-content-center'>
        <Button color={'success'} className={`px-4`} onClick={AddInscricaoMunicipal}>
          <FontAwesomeIcon icon={faSave} /> Salvar
        </Button>
      </div>
    </MainCard>
  </>
}

export default NovoInscricoesMunicipais;